import Styled, { css } from 'styled-components';
import check from '@catalogo/ui-americanas-desktop-svg/check.svg';

const Option = Styled.div`
  position: relative;
  align-items: center;
  line-height: 40px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  padding: 0 16px;
  border-top: 1px solid #DFDFDF;

  > label {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
`;

interface Checkmark {
  checked: boolean;
}

const Checkmark = Styled(check)<Checkmark>`
  cursor: pointer;
  width: 16px;
  height: 16px;
  border: 2px solid #a9a9a9;
  border-radius: 6px;
  background: #ffffff;
  fill: #ffffff;

  ${({ checked, theme }) =>
    checked &&
    css`
      background-color: ${theme.primaryColor};
      border-color: ${theme.primaryColor};
    `}
`;

const Select = Styled.div`
  &:last-child {
   border-bottom: none;
  }
`;

export default Select;
export { Select, Option, Checkmark };
